const pf = v => parseFloat(v.replace(".", "").replace(",", "."));
const fn = v =>
  Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(v);

export default {
  setItens (state, payload) {
    state.itens = payload;
  },
  setProdutos (state, payload) {
    state.produtos = payload.filter(
      f => !state.item.produtos.some(i => i.produto_id === f.produto_id)
    );
  },
  setItem (state, payload) {
    state.item = payload;
  },
  setItensProdutos (state, payload) {
    state.item.produtos = payload;
  },
  setItemProdutos (state, payload) {
    payload.forEach(e => {
      e.desconto = state.item.desconto;
      e.crescimento = state.item.crescimento;
      e.preco_evento = fn(
        pf(e.preco_medio_venda) -
        (pf(e.desconto) * pf(e.preco_medio_venda)) / 100
      );
      let dpc = pf(e.preco_custo) > 0 ? pf(e.preco_custo) - 1 : 1;
      e.markup_evento = fn((pf(e.preco_evento) / dpc) * 100);
      e.base = state.item.desconto;
      e.previsao_venda_evento = e.a || e.b ? fn(parseFloat(e.a) + parseFloat(e.b) * pf(e.preco_evento)) : '0,00';
      let dpv = pf(e.previsao_venda) != 0 ? pf(e.previsao_venda) : 1;
      e.crescimento = fn(
        (pf(e.previsao_venda_evento) / dpv) * 100
      );
      state.item.produtos.push(e);
    });
  },
  setItemProdutoPreco (state, payload) {
    let item = state.item.produtos.find(
      ip => ip.produto_id == payload.produto_id
    );
    if (!item.preco_evento) {
      item.preco_evento = item.preco_medio_venda;
    }
    let dpc = pf(item.preco_custo) > 0 ? pf(item.preco_custo) : 1;
    let pmv = (pf(item.preco_evento) / dpc) == 0 ? "1" : pf(item.preco_evento) / dpc
    item.markup_evento = fn(pmv * 100 - 100);
    let dpmv = pf(item.preco_medio_venda) != 0 ? pf(item.preco_medio_venda) : 1;

    item.desconto = fn(100 - (pf(item.preco_evento) * 100) / dpmv);
    item.base = item.desconto;
    item.previsao_venda_evento = item.a || item.b ? fn(
      parseFloat(item.a) + parseFloat(item.b) * pf(item.preco_evento)
    ) : '0,00';
    let dpv = pf(item.previsao_venda) != 0 ? pf(item.previsao_venda) : 1;
    item.crescimento = fn(
      (pf(item.previsao_venda_evento) / dpv) * 100 - 100
    );
  },
  setItemProdutoMarkup (state, payload) {
    let item = state.item.produtos.find(
      ip => ip.produto_id == payload.produto_id
    );
    item.preco_evento = fn(
      pf(item.preco_custo) +
      (pf(item.preco_custo) * pf(item.markup_evento)) / 100
    );
    let dpmv = pf(item.preco_medio_venda) != 0 ? pf(item.preco_medio_venda) : 1;
    item.desconto = fn(100 - (pf(item.preco_evento) * 100) / dpmv);
    item.previsao_venda_evento = item.a || item.b ? fn(
      parseFloat(item.a) + parseFloat(item.b) * pf(item.preco_evento)
    ) : '0,00';
    let dpv = pf(item.previsao_venda) != 0 ? pf(item.previsao_venda) : 1;
    item.crescimento = fn(
      (pf(item.previsao_venda_evento) / dpv) * 100 - 100
    );
  },
  setItemProdutoDesconto (state, payload) {
    let item = state.item.produtos.find(
      ip => ip.produto_id == payload.produto_id
    );
    if (!item.desconto) {
      item.desconto = item.base;
    }
    item.preco_evento = fn(
      pf(item.preco_medio_venda) -
      (pf(item.desconto) * pf(item.preco_medio_venda)) / 100
    );
    let dpc = pf(item.preco_custo) > 0 ? pf(item.preco_custo) : 1;
    let pmv = (pf(item.preco_evento) / dpc) == 0 ? "1" : pf(item.preco_evento) / dpc
    item.markup_evento = fn(pmv * 100 - 100);
    item.base = item.desconto;
    item.previsao_venda_evento = item.a || item.b ? fn(
      parseFloat(item.a) + parseFloat(item.b) * pf(item.preco_evento)
    ) : '0,00';
    let dpv = pf(item.previsao_venda) != 0 ? pf(item.previsao_venda) : 1;
    item.crescimento = fn(
      (pf(item.previsao_venda_evento) / dpv) * 100 - 100
    );
  },
  deleteItemProdutos (state, payload) {
    state.item.produtos.splice(
      state.item.produtos.findIndex(ip => ip.produto_id == payload.produto_id),
      1
    );
  }
};
